import { DataManager } from "../Managers/DataManager";

export class Vibration {
    /**
     * To perform multiple vibration, an array needs to be passed as the parameter.
     * First value represents vibration time (milliseconds), second value represents pause time (milliseconds),
     * third value represents vibration time, and this goes on with each alternate value.
     * Basically it is performed as a series of [VIBRATION] [PAUSE] [VIBRATION] [PAUSE] [VIBRATION] [PAUSE]...
     *
     * Use 0 to force stop vibration
     *
     * @param pattern
     */
    public static vibrate(pattern: number | Array<number> = 0): void {
        if (!DataManager.VibrationEnabled) {
            return;
        }

        if (navigator.vibrate == null) {
            return;
        }

        navigator.vibrate(pattern);
    }
}



/** WEBPACK FOOTER **
 ** ./Engine/Game/Utils/Vibration.ts
 **/